import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import car from "../../assets/images/office.jpg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Bezahlung = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="service-section bg-light">
      <Container className="px-4 px-md-5 py-5">
        <Row className="mb-5 text-center" data-aos="fade-down">
          <Col>
            <h2 className="fw-bold text-orange">
              {t("Bezahlung.title")}
            </h2>
          </Col>
        </Row>

        <Row className="align-items-center gy-4">
          <Col md={6} data-aos="fade-right" className="text-center">
            <img
              src={car}
              alt="Spedition Transport"
              className="img-fluid rounded shadow img-map"
            />
          </Col>
          <Col md={6} data-aos="fade-left">
            <h5 className="text-orange fw-semibold">
              {t("Bezahlung.subtitle")}
            </h5>

            <p className="text-muted fw-semibold fs-6 mt-3">
              {t("Bezahlung.description_1")}
            </p>

            <p className="text-muted fw-semibold fs-6">
              {t("Bezahlung.description_2")}
            </p>

            <p className="text-muted fw-semibold fs-6">
              {t("Bezahlung.description_3")}
            </p>

            <p className="text-muted fw-semibold fs-6">
              {t("Bezahlung.description_4")}
            </p>

            <p className="text-muted fw-semibold fs-6">
              {t("Bezahlung.description_5")}
            </p>

            <Button
              variant="warning"
              size="lg"
              className="bg-orange-500 text-white mt-3"
              onClick={() => navigate("/contact")}
            >
              {t("Bezahlung.button")}
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Bezahlung;